import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MarketProductDetailNRO = lazy(() =>
  import("@scenes/Catalogs/MarketProductDetailNRO").then((module) => ({
    default: module.MarketProductDetailNRO,
  }))
);

export const dashboardCatalogsCatalogIdProductItemIdNRO: NavigationRoutingObject = {
  Component: MarketProductDetailNRO,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("dashboard-catalogs-catalog-id-product-item-id-nro-heading", "Product details"),
  pageNameForTracking: () => "Catalog Product Detail",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("dashboard-catalogs-catalog-id-product-item-id-nro-description", "View market product details"),
  icon: "nav-system-catalog",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("shopify_markets_support"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/catalogs/:appGroupId",
};
